import styled from "@emotion/styled";

/** 내 악보 만들기 화면 공통 모양 (새 디자인 어두운 화면 — RequestScore 와 같은 색) */
export const C = {
  fg: "#f3f4f6",
  muted: "#a3a9b5",
  dim: "#7c8392",
  line: "#2a2e38",
  card: "#16181e",
  accent: "#5b8cff",
  link: "#8fb0ff",
  ok: "#5fd39a",
  warn: "#ffb547",
  err: "#ff9a9a",
};

export const Page = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 16px 16px 110px;
  color: ${C.fg};
  & > h1 {
    margin: 0 0 6px;
    font-size: 24px;
    font-weight: 700;
    color: ${C.fg};
  }
`;

export const Lead = styled.p`
  margin: 0 0 18px;
  font-size: 15px;
  line-height: 1.6;
  color: ${C.muted};
  word-break: keep-all;
`;

export const Card = styled.div`
  background: ${C.card};
  border: 1px solid ${C.line};
  border-radius: 14px;
  padding: 14px 16px;
`;

export const Primary = styled.button`
  height: 52px;
  width: 100%;
  border-radius: 14px;
  border: 0;
  background: ${C.accent};
  color: #0d0e12;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  &:disabled {
    background: ${C.line};
    color: ${C.dim};
    cursor: default;
  }
`;

export const Ghost = styled.button`
  height: 44px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid ${C.line};
  background: transparent;
  color: ${C.fg};
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  &:disabled {
    color: ${C.dim};
    cursor: default;
  }
  &.danger {
    color: ${C.err};
  }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  & > span {
    font-size: 13px;
    color: ${C.muted};
  }
  & > span > em {
    font-style: normal;
    color: ${C.dim};
  }
  & > input,
  & > textarea {
    padding: 0 14px;
    border-radius: 12px;
    border: 1px solid ${C.line};
    background: ${C.card};
    color: ${C.fg};
    font-size: 16px;
    outline: 0;
    font-family: inherit;
  }
  & > input {
    height: 50px;
  }
  & > textarea {
    min-height: 120px;
    padding: 12px 14px;
    line-height: 1.5;
    resize: vertical;
  }
  & > input:focus,
  & > textarea:focus {
    border-color: ${C.accent};
  }
`;

export const Err = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${C.err};
  line-height: 1.5;
`;

export const Note = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${C.dim};
  line-height: 1.5;
  word-break: keep-all;
`;

export const Chip = styled.span<{ tone?: "ok" | "warn" | "err" | "dim" }>`
  display: inline-block;
  flex: none;
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  padding: 2px 9px;
  color: ${({ tone }) => (tone === "ok" ? C.ok : tone === "warn" ? C.warn : tone === "err" ? C.err : C.muted)};
  background: ${({ tone }) =>
    tone === "ok" ? "rgba(95,211,154,.12)" : tone === "warn" ? "rgba(255,181,71,.12)" : tone === "err" ? "rgba(255,154,154,.12)" : "rgba(163,169,181,.12)"};
`;

/** 아래에서 올라오는 선택 창 */
export const Sheet = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  & > div {
    width: 100%;
    max-width: 600px;
    max-height: 85vh;
    overflow-y: auto;
    box-sizing: border-box;
    background: #1b1e25;
    border-radius: 18px 18px 0 0;
    padding: 20px 16px calc(20px + env(safe-area-inset-bottom, 0px));
    color: ${C.fg};
  }
  & h2 {
    margin: 0 0 14px;
    font-size: 18px;
  }
`;

export const Option = styled.button<{ on?: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  box-sizing: border-box;
  padding: 12px 14px;
  margin-bottom: 8px;
  border-radius: 12px;
  border: 1px solid ${({ on }) => (on ? C.accent : C.line)};
  background: ${({ on }) => (on ? "rgba(91,140,255,.14)" : C.card)};
  color: ${C.fg};
  font-size: 15px;
  cursor: pointer;
  & > b {
    display: block;
    font-weight: 700;
  }
  & > span {
    display: block;
    margin-top: 2px;
    font-size: 13px;
    color: ${C.muted};
    word-break: keep-all;
  }
`;

export const errText = (e: any, fallback = "잠시 뒤 다시 시도해 주세요.") =>
  (e && e.response && e.response.data && e.response.data.alert) || fallback;
